const UriUtils = (() => {
  const service = {};

  const toQueryString = (query) => {
    let queryString = '?';
    const keys = Object.keys(query);
    const maxSize = keys.length;
    let count = 0;

    keys.forEach((key) => {
      const value = encodeURIComponent(query[key]);
      queryString += `${key}=${value}`;
      count += 1;
      if (count < maxSize) {
        queryString += '&';
      }
    });
    return queryString;
  };

  service.toQueryString = toQueryString;
  return service;
})();

export default UriUtils;
